import React from "react";
import { useTranslation } from "~/lib/utils/store/useTranslation";

interface IContactCardProps {
  name: string;
  phoneNo: string;
}

const ContactCard = ({ name = "", phoneNo = "" }: IContactCardProps) => {
  const { t } = useTranslation();
  return (
    <>
      <p className="text-mediumgrey text-sm font-medium pb-1">
        {t("userDetails")}
      </p>
      <div className="border border-gray-50 rounded-lg divide-y divide-solid px-4 ">
        <div className="py-4">
          <label className="font-medium text-mediumgrey text-sm pb-1">
            {t("name")}
          </label>
          <p className="text-base font-normal">{name}</p>
        </div>
        <div className="py-4">
          <label className="font-medium text-mediumgrey text-sm pb-1">
            {t("phoneNo")}
          </label>
          <p className="text-base font-normal">+{phoneNo}</p>
        </div>
      </div>
    </>
  );
};

export default ContactCard;
